import { Button } from "@/components/Buttons";
import { useAdultModeQuery, useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import { useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OpenApp(_ref) {
  var watch = _ref.watch;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;

  var _ref2 = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {},
      isAndroid = _ref2.isAndroid;

  var isIOS = maybeIOS(deviceInfo);
  var openApp = useCallback(function () {
    if (isIOS) {
      window.location.href = "spoox://watch/".concat(watch.episode.id);
      var launchId = setTimeout(function () {
        window.location.href = config.appStoreUrl.ios;
      }, 500);

      var blurFunc = function blurFunc() {
        clearTimeout(launchId);
        window.removeEventListener("blur", blurFunc);
      };

      window.focus();
      window.addEventListener("blur", blurFunc);
    } else if (isAndroid) {
      if (adultMode) {
        var _config$firebaseDynam = config.firebaseDynamicLinks.adult,
            domain = _config$firebaseDynam.domain,
            android = _config$firebaseDynam.android,
            fallbackLink = _config$firebaseDynam.fallbackLink;
        var deeplink = "".concat(config.host.adult, "/watch/").concat(watch.episode.id);
        var encodedDeeplink = encodeURIComponent(deeplink);
        var encodedFallbacLink = encodeURIComponent(fallbackLink);
        window.location.href = "https://".concat(domain, ".page.link/?link=").concat(encodedDeeplink, "&apn=").concat(android.packageName, "&afl=").concat(encodedFallbacLink);
      } else {
        window.location.href = "intent://watch/".concat(watch.episode.id, "#Intent;scheme=spoox;package=").concat(config.androidPackageName, ";end");
      }
    }
  }, [isAndroid, isIOS]);
  return /*#__PURE__*/_jsx(Button, {
    fillColor: true,
    large: true,
    onClick: openApp,
    children: "\u30A2\u30D7\u30EA\u3067\u8996\u8074\u3059\u308B"
  });
}